import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../hooks';
import { SimulcastTable } from '../../../elements';
import { schema } from './schema';
import 'mobx-react-lite/batchingForReactDom';

const LanesHome = observer(({ AuctionID, auctionName }) => {
  const {
    AuctionStore: { isLoading, getLanesByAuctionId, lanes: data, totalItems },
  } = useStores();

  const {
    headerSchema,
    tableSettings: {
      getMethods,
      initialSortColumn,
      initialSortDirection,
      pageSelectTitle,
      searchFields,
    },
    bodySchema,
    debugging,
  } = schema;

  const lanes = { auctionId: AuctionID, fn: getLanesByAuctionId };
  const methods = getMethods(lanes);

  return (
    <SimulcastTable
      bodySchema={bodySchema}
      debugging={debugging}
      headerSchema={headerSchema}
      initialMediaState={null}
      initialSortDirection={initialSortDirection}
      initialSortColumn={initialSortColumn}
      isLoading={isLoading}
      methods={methods}
      pageSelectTitle={pageSelectTitle}
      searchFields={searchFields}
      rowData={data}
      state={{ auctionName }}
      totalItems={totalItems}
      exportButton={{
        visible: data.length > 0,
        fileName: `LanesReport-${auctionName}`,
        sheetName: 'Lane List',
        showLocation: ['top'],
      }}
    />
  );
});

export default LanesHome;
